function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16.693 64.652)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.066 -64.302)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.939)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M40.377-45.19a1.9,1.9,0,0,1-1.117-.369,1.871,1.871,0,0,1-.69-2.126l1.94-5.954L35.435-57.3a1.871,1.871,0,0,1-.7-2.125,1.871,1.871,0,0,1,1.808-1.316H42.8l1.909-5.937A1.871,1.871,0,0,1,46.519-68h0a1.871,1.871,0,0,1,1.807,1.314l1.926,5.941h.678a.505.505,0,0,1,.505.505.505.505,0,0,1-.505.505H49.888a.505.505,0,0,1-.481-.35l-2.039-6.29a.867.867,0,0,0-.846-.615h0a.867.867,0,0,0-.846.617l-2.022,6.287a.505.505,0,0,1-.481.351H36.547a.867.867,0,0,0-.846.616.867.867,0,0,0,.326.995l5.375,3.88a.505.505,0,0,1,.185.566l-2.054,6.3a.867.867,0,0,0,.323,1,.867.867,0,0,0,1.046,0l5.359-3.9a.505.505,0,0,1,.595,0L52.2-46.4a.867.867,0,0,0,1.047,0,.867.867,0,0,0,.321-1l-2.058-6.273a.505.505,0,0,1,.184-.567l5.361-3.887a.867.867,0,0,0,.324-.994.867.867,0,0,0-.846-.615H55.482a.505.505,0,0,1-.505-.505.505.505,0,0,1,.505-.505h1.046a1.872,1.872,0,0,1,1.807,1.314,1.872,1.872,0,0,1-.692,2.124l-5.062,3.671,1.943,5.923a1.871,1.871,0,0,1-.686,2.128,1.871,1.871,0,0,1-2.236,0L46.558-49.25,41.5-45.561a1.894,1.894,0,0,1-1.119.371Z",
  transform: "translate(-34.643 68)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.328 20.777)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25386",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25386",
  d: "M260.505,348.221a.505.505,0,0,1-.505-.505v-4.087a.505.505,0,0,1,1.011,0v4.087A.505.505,0,0,1,260.505,348.221Z",
  transform: "translate(-260 -343.123)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.768 14.645)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25387",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25387",
  d: "M431.4,224.054a.505.505,0,0,1-.156-.025l-3.887-1.263a.505.505,0,0,1,.312-.961l3.887,1.263a.505.505,0,0,1-.156.986Z",
  transform: "translate(-427.011 -221.78)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.544 1.416)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M363.724-35.668a.5.5,0,0,1-.3-.1.505.505,0,0,1-.112-.706l2.4-3.307a.505.505,0,0,1,.706-.112.505.505,0,0,1,.112.706l-2.4,3.307A.5.5,0,0,1,363.724-35.668Z",
  transform: "translate(-363.218 39.986)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.709 1.416)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25389",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25389",
  d: "M112.15-35.668a.5.5,0,0,1-.409-.208l-2.4-3.307a.505.505,0,0,1,.112-.706.505.505,0,0,1,.706.112l2.4,3.307a.505.505,0,0,1-.112.706A.5.5,0,0,1,112.15-35.668Z",
  transform: "translate(-109.242 39.985)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 14.644)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M16.572,224.052a.505.505,0,0,1-.156-.986L20.3,221.8a.505.505,0,0,1,.312.961l-3.887,1.263A.507.507,0,0,1,16.572,224.052Z",
  transform: "translate(-16.066 -221.778)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.779 -59.708)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M392.568,76.715a.578.578,0,1,1,.408-.169A.582.582,0,0,1,392.568,76.715Z",
  transform: "translate(-391.99 -75.56)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star",
    className: "fill-stroke",
    width: 26.391,
    height: 26.575,
    viewBox: "0 0 26.391 26.575",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.1303acc4.svg";
export { ForwardRef as ReactComponent };